import React, {
  Fragment,
  useState,
  useEffect,
  createRef,
  useRef,
  useContext,
  useCallback,
} from "react";
import { useForm, Controller } from "react-hook-form";
import { Btn, H5, H3, H4, H6, LI, P, UL } from "../../../AbstractElements";
import { Col, Container, Label, Row, CardBody, Card, Table } from "reactstrap";
import axios from "axios";
//import TableSkeleton from "../../Skeleton/TableSkeleton";
import * as mutations from "../../../graphql/mutations";
import * as queries from "../../../graphql/queries";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import moment from "moment";
import Select from "react-select";
import cloneDeep from "lodash/cloneDeep";
import { useNavigate, useLocation, Link } from "react-router-dom";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { SiteContext } from "../../../App";
import { aocontext } from "../../../App";
import { PlusCircle } from "react-feather";
import { toast } from "react-toastify";
import { Typeahead } from "react-bootstrap-typeahead";
import SiteData from "../../../Data/Sites/index";
import CategoryData from "../../../Data/Category/index";
import { limit } from "../../../Config/Config";
import { generateClient } from "aws-amplify/api";
const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});
var base64 = require("base-64");

const UpdateDB = () => {
  const navigate = useNavigate();
  const state = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [sites, setSites] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const countPerPage = 10;
  const countPerPage2 = 10;
  const [currentPage2, setCurrentPage2] = useState(1);
  const LoginUserGroup = localStorage.getItem("groups");
  const LoginUserDetails = JSON.parse(localStorage.getItem("userDetails"));
  const [siteDetails, setSiteDetails] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [fullassets, setFullassets] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [categoryDetails, setCategoryDetails] = useState([]);
  const [siteError, setSiteError] = useState(false);
  const [catassets, setCatAssets] = useState([]);
  const [isAllSelectedOpen, setIsAllSelectedOpen] = useState(false);
  let itemss = [];
  const catid =
    state.state && state.state.category ? state.state.category.id : "";
  const [distributionBoxList, setDistributionBoxList] = useState([]);
  const [isCheckboxCheckedOpen, setIsCheckboxCheckedOpen] = useState([]);
  const { selectedSiteGlobal, handleSiteChange } = useContext(SiteContext);
  const { selectedAssetOwnerGlobal, handleAssetOwner } = useContext(aocontext);
  const [selectedItemsOpen, setSelectedItemsOpen] = useState([]);
  const [selectedDB, setSelectedDB] = useState(null);
  const [selectedDBname, setSelectedDBname] = useState(null);
  const [selectedsitename, setSelectedsitename] = useState(null);
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
    e,
    ...form
  } = useForm();

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    if (localStorage.getItem("site") === null && sites.length === 0) {
      LoginUserGroup === "site_owner" || LoginUserGroup === "spao"
        ? fetchSiteDetailsAO()
        : fetchSiteDetailsSPSU(LoginUserDetails.id);
    } else {
      let activeSites = JSON.parse(base64.decode(localStorage.getItem("site")));
      setSites(activeSites.filter((item) => item.status === "Active"));
      setSiteDetails(activeSites.filter((item) => item.status === "Active"));
    }
    if (
      localStorage.getItem("category") === null &&
      categoryDetails.length === 0
    ) {
      fetchCategory();
    } else {
      setCategoryDetails(CategoryData.getCategoryData());
    }
  }, [selectedSiteGlobal, selectedAssetOwnerGlobal]);

  async function fetchCategory() {
    try {
      let nextToken = "";
      let categories = [];
      const dataDetails = await client.graphql({
        query: queries.listCategories,
        authMode: "API_KEY",
        variables: {
          limit: 200000,
        },
      });
      if (dataDetails.data.listCategories.items.length > 0) {
        let assetDatas = dataDetails.data.listCategories.items;
        nextToken = dataDetails.data.listCategories.nextToken;
        if (dataDetails.data.listCategories.items.length > 0) {
          categories.push(assetDatas);
        }
        while (nextToken !== null) {
          const dataDetailss = await client.graphql({
            query: queries.listCategories,
            variables: {
              limit: 200000,
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          if (dataDetailss.data.listCategories.items.length > 0) {
            nextToken = dataDetailss.data.listCategories.nextToken;
            categories.push(dataDetailss.data.listCategories.items);
          } else {
            nextToken = null;
          }
        }
        console.log(categories);
        if (categories.length > 0) {
          const mergeCategories = categories.flat(1);
          setCategoryDetails(mergeCategories);
          CategoryData.setCategoryData(mergeCategories);
          localStorage.setItem(
            "category",
            base64.encode(JSON.stringify(mergeCategories)),
          );
        }
      }
    } catch (error) {
      console.error(error);
      setCategoryDetails([]);
      CategoryData.setCategoryData([]);
    }
  }

  async function fetchSiteDetailsAO() {
    try {
      let nextToken = "";
      let sites = [];
      const result = await client.graphql({
        query: queries.siteDetailsByAssetownerID,
        variables: {
          assetownerID: LoginUserDetails.id,
          limit: 200000,
        },
        authMode: "API_KEY",
      });
      if (result.data.siteDetailsByAssetownerID.items.length > 0) {
        let assetDatas = result.data.siteDetailsByAssetownerID.items;
        nextToken = result.data.siteDetailsByAssetownerID.nextToken;
        if (result.data.siteDetailsByAssetownerID.items.length > 0) {
          sites.push(assetDatas);
        }
        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.siteDetailsByAssetownerID,
            variables: {
              assetownerID: LoginUserDetails.id,
              limit: 200000,
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          if (results.data.siteDetailsByAssetownerID.items.length > 0) {
            nextToken = results.data.siteDetailsByAssetownerID.nextToken;
            sites.push(results.data.siteDetailsByAssetownerID.items);
          } else {
            nextToken = null;
          }
        }
        console.log(sites);
        if (sites.length > 0) {
          const mergeSites = sites.flat(1);
          setSites(mergeSites.filter((item) => item.status === "Active"));
          SiteData.setSiteData(mergeSites);
          localStorage.setItem(
            "site",
            base64.encode(JSON.stringify(mergeSites)),
          );
        } else {
          setSites([]);
          setIsLoading(false);
        }
      } else {
        setSites([]);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      setSites([]);
      setIsLoading(false);
    }
  }

  //--sites for sp/su
  async function fetchSiteDetailsSPSU(assetOwnerId) {
    try {
      let nextToken = "";
      let linkedSites = [];
      const result = await client.graphql({
        query: queries.linkUsersAndSitesByUserdetailsID,
        authMode: "API_KEY",
        variables: {
          userdetailsID: assetOwnerId,
          filter: {
            status: {
              eq: "Active",
            },
          },
          limit: limit,
        },
      });
      if (result.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
        let assetDatas = result.data.linkUsersAndSitesByUserdetailsID.items;
        nextToken = result.data.linkUsersAndSitesByUserdetailsID.nextToken;
        if (result.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
          linkedSites.push(assetDatas);
        }
        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.linkUsersAndSitesByUserdetailsID,
            authMode: "API_KEY",
            variables: {
              userdetailsID: assetOwnerId,
              filter: {
                status: {
                  eq: "Active",
                },
              },
              limit: limit,
              nextToken: nextToken,
            },
          });
          if (results.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
            nextToken = results.data.linkUsersAndSitesByUserdetailsID.nextToken;
            linkedSites.push(
              results.data.linkUsersAndSitesByUserdetailsID.items,
            );
          } else {
            nextToken = null;
          }
        }
        console.log(linkedSites);
        if (linkedSites.length > 0) {
          const mergeSites = linkedSites.flat(1);
          let sitesforUsers = [];
          const promises = mergeSites.map(async (item) => {
            return await client.graphql({
              query: queries.getSiteDetails,
              variables: {
                id: item.sitedetailsID,
              },
              authMode: "API_KEY",
            });
          });
          Promise.all(promises).then((sitesData) => {
            sitesData.forEach((sites) => {
              if (sites.data.getSiteDetails !== null) {
                sitesforUsers.push(sites.data.getSiteDetails);
              }
            });
            setSites(sitesforUsers.filter((item) => item.status === "Active"));
            setSiteDetails(
              sitesforUsers.filter((item) => item.status === "Active"),
            );
            localStorage.setItem(
              "site",
              base64.encode(JSON.stringify(sitesforUsers)),
            );
            //SiteData.setSiteData(sitesforUsers);
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const setSite = (site) => {
    console.log(site);
    if (site.length > 0) {
      setSiteError(false);
      setSelectedsitename(site[0].siteName);
      console.log(site[0].id);
      setSiteId(site[0].id);
      fetchAssets(site[0].id);
      fetchDB(site[0].id);
    } else {
      setSiteError(true);
    }
  };

  useEffect(() => {
    // fetchAssets(siteId);
    // fetchDB(siteId);
  }, [siteId]);

  async function fetchDB(site) {
    try {
      let nextToken = "";
      let assets = [];

      const dbList = await client.graphql({
        query: queries.distributionBoxesBySitedetailsID,
        variables: {
          sitedetailsID: site,
          filter: {
            status: {
              eq: "Active",
            },
          },
          limit: limit,
        },
        authMode: "API_KEY",
      });
      if (dbList.data.distributionBoxesBySitedetailsID.items.length > 0) {
        let assetDatas = dbList.data.distributionBoxesBySitedetailsID.items;
        nextToken = dbList.data.distributionBoxesBySitedetailsID.nextToken;
        if (dbList.data.distributionBoxesBySitedetailsID.items.length > 0) {
          assets.push(assetDatas);
        }
        while (nextToken !== null) {
          const dbList1 = await client.graphql({
            query: queries.distributionBoxesBySitedetailsID,
            variables: {
              limit: limit,
              sitedetailsID: site,
              filter: {
                status: {
                  eq: "Active",
                },
              },
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          if (dbList1.data.distributionBoxesBySitedetailsID.items.length > 0) {
            nextToken = dbList1.data.distributionBoxesBySitedetailsID.nextToken;
            if (
              dbList1.data.distributionBoxesBySitedetailsID.items.length > 0
            ) {
              assets.push(dbList1.data.distributionBoxesBySitedetailsID.items);
            }
          } else {
            nextToken = null;
          }
        }
        if (assets.length > 0) {
          const mergeAssets = assets.flat(1);
          setDistributionBoxList(mergeAssets);
        } else {
          setDistributionBoxList([]);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchAssets(site) {
    try {
      // 1 Get Asset Templates
      if (!site) {
        setTasks([]);
        setFullassets([]);
        return;
      }
      setIsLoading(true);
      const assetTemplateResults = await client.graphql({
        query: queries.assetTemplatesByCategoriesID,
        variables: {
          categoriesID: catid,
          filter: {
            status: { eq: "Active" },
          },
          limit: 800,
        },
        authMode: "API_KEY",
      });

      const templates =
        assetTemplateResults.data.assetTemplatesByCategoriesID.items;

      if (!templates.length) return;

      let allAssets = [];

      // 2 Fetch assets for each template
      await Promise.all(
        templates.map(async (template) => {
          let nextToken = null;
          const assetSiteTemp = `${template.id}_${site}`;
          console.log("assetSiteTemp", assetSiteTemp);
          do {
            const assetResults = await client.graphql({
              query: queries.assetsByAssettemplateSiteIDAndAssetNum,
              variables: {
                assettemplateSiteID: assetSiteTemp,
                limit: 1000,
                nextToken: nextToken,
                filter: {
                  status: { ne: "delete" },
                },
              },
              authMode: "API_KEY",
            });
            console.log("assetResults", assetResults);
            const assetData =
              assetResults.data.assetsByAssettemplateSiteIDAndAssetNum;

            if (assetData.items.length > 0) {
              allAssets = [...allAssets, ...assetData.items];
            }

            nextToken = assetData.nextToken;
          } while (nextToken);
        }),
      );

      // 3 Update state once
      setTasks(cloneDeep(allAssets.slice(0, countPerPage)));
      setFullassets(allAssets);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching assets:", error);
    } finally {
      setIsLoading(false);
    }
  }

  function getSiteName(id) {
    const siteName = siteDetails.find((item) => item.id === id);
    return siteName
      ? siteName.siteName + " " + "(" + siteName.unitNumber + ")"
      : "";
  }

  // const handleCheckboxChangeOpen = (event, item) => {
  //     try {
  //         console.log(item);
  //         console.log(itemss);

  //         const isChecked = event.target.checked;
  //         if (item === "selectAll") {
  //             setIsAllSelectedOpen(isChecked);

  //             if (isChecked) {
  //                 const allItems = tasks.map((item) => item);
  //                 setSelectedItemsOpen(allItems);
  //                 itemss = allItems;
  //             } else {
  //                 setSelectedItemsOpen([]);
  //                 itemss = [];
  //             }
  //         } else {
  //             if (isChecked) {
  //                 setIsCheckboxCheckedOpen(item);
  //                 setSelectedItemsOpen((prevSelectedItems) => [
  //                     ...prevSelectedItems,
  //                     item,
  //                 ]);
  //                 itemss = [...itemss, item];
  //             } else {
  //                 setIsCheckboxCheckedOpen(null);
  //                 setSelectedItemsOpen((prevSelectedItems) =>
  //                     prevSelectedItems.filter((selectedItem) => selectedItem !== item)
  //                 );
  //                 itemss = itemss.filter((selectedItem) => selectedItem !== item);
  //             }

  //             // Check if all items are selected
  //             console.log(itemss);
  //             const allSelected = tasks.every((item) => itemss.includes(item));
  //             console.log(allSelected);
  //             setIsAllSelectedOpen(allSelected);
  //         }
  //     }
  //     catch (error) {
  //         console.error(error);
  //     }
  // };

  useEffect(() => {
    const allSelected =
      fullassets.length > 0 && selectedItemsOpen.length === fullassets.length;

    setIsAllSelectedOpen(allSelected);
  }, [selectedItemsOpen, fullassets]);

  const handleCheckboxChangeOpen = (event, item) => {
    try {
      const isChecked = event.target.checked;

      //  SELECT ALL (ALL PAGES)
      if (item === "selectAll") {
        if (isChecked) {
          const allIds = fullassets.map((asset) => asset.id);
          setSelectedItemsOpen(allIds);
          setIsAllSelectedOpen(true);
        } else {
          setSelectedItemsOpen([]);
          setIsAllSelectedOpen(false);
        }
        return;
      }

      //  SINGLE CHECKBOX
      setSelectedItemsOpen((prevSelected) => {
        let updatedSelection;

        if (isChecked) {
          updatedSelection = [...prevSelected, item.id];
        } else {
          updatedSelection = prevSelected.filter((id) => id !== item.id);
        }

        //  Check if ALL assets are selected (not just current page)
        const allSelected =
          fullassets.length > 0 &&
          updatedSelection.length === fullassets.length;

        setIsAllSelectedOpen(allSelected);

        return updatedSelection;
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteTasks = async () => {
    try {
      console.log("updating selected assets:", selectedItemsOpen);

      if (!selectedItemsOpen.length) return;

      //  IF MORE THAN 20 → CALL LAMBDA
      if (selectedItemsOpen.length > 20) {
        try {
          toast.success(
            "Bulk update initiated successfully. We will email you once completed",
            { position: toast.POSITION.TOP_CENTER },
          );

          //  Call API but DO NOT wait for it
          axios
            .post(
              "https://a2x2uqpam0.execute-api.ap-southeast-2.amazonaws.com/prod/bulk-update-assets",
              {
                assetIds: selectedItemsOpen,
                distributionboxID: selectedDB,
                userEmail: LoginUserDetails.email,
                siteName: selectedsitename,
                username: LoginUserDetails.username,
                distributionbox: selectedDBname.label,
                cat: state.state.category.categoryName,
              },
            )
            .catch((error) => {
              console.error("Bulk update background error:", error);
            });

          // Navigate immediately
          navigate(`${process.env.PUBLIC_URL}/assets`, {
            state: {
              category: state.state.category,
            },
          });
        } catch (error) {
          console.error("Bulk update error:", error);
        }
      } else {
        //  20 OR LESS → NORMAL GRAPHQL UPDATE

        await Promise.all(
          selectedItemsOpen.map((id) =>
            client.graphql({
              query: mutations.updateAssets,
              variables: {
                input: {
                  id: id,
                  distributionboxID: selectedDB,
                },
              },
              authMode: "API_KEY",
            }),
          ),
        );

        toast.success("Updated Distribution box successfully.", {
          position: toast.POSITION.TOP_CENTER,
        });
        // Navigate only after completion
        navigate(`${process.env.PUBLIC_URL}/assets`, {
          state: {
            category: state.state.category,
          },
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!");
    }
  };

  const updatePage3 = (p) => {
    setCurrentPage2(p);
    const to = countPerPage2 * p;
    const from = to - countPerPage2;
    const data = fullassets;
    setTasks(cloneDeep(data.slice(from, to)));
  };

  const optionsCategory = [
    { value: "", label: "Select Distribution Board" },
    ...distributionBoxList.map((item) => ({
      value: item.id,
      label: item.distributionBoxName,
    })),
  ];

  const getDBName = (dbId) => {
    try {
      const db = distributionBoxList.filter((db) => {
        return db.id === dbId;
      });
      return db.length > 0 ? db[0].distributionBoxName : "";
    } catch (error) {
      //console.log("display DB name", error);
      return "";
    }
  };

  //--- category dropdown
  const handleDB = (event) => {
    const selectedCategoryId = event.value;
    setSelectedDB(selectedCategoryId);

    // if (selectedCategoryId === "") {
    //     setTasks(filtertask);
    //     return;
    // }

    // const filteredTasks = filtertask.filter((task) => {
    //     try {
    //         const link = JSON.parse(task.taskCompletionLink);
    //         const categoryInTask = link?.[0]?.category;
    //         return categoryInTask === selectedCategoryId;
    //     } catch (error) {
    //         console.error("Invalid taskCompletionLink JSON:", task.taskCompletionLink);
    //         return false;
    //     }
    // });
    // console.log(filteredTasks);
    // setTasks(filteredTasks);
  };

  const cancelForm = () => {
    navigate(`${process.env.PUBLIC_URL}/assets`, {
      state: {
        category: state.state.category,
      },
    });
  };

  const renderList = (
    <Fragment>
      <Container fluid={true}>
        {state.state && state.state.category && (
          <H4>{state.state.category.categoryName}</H4>
        )}
        <br></br>
        <Col md="12" className="project-list">
          <Card className="custom-card">
            <Row></Row>
            <Row>
              <Col md="5 mb-3">
                <Typeahead
                  id="rendering-example"
                  multiple={false}
                  options={siteDetails}
                  labelKey={(siteDetails) =>
                    `${siteDetails.siteName} ,(${
                      siteDetails.unitNumber ? siteDetails.unitNumber : ""
                    })`
                  }
                  placeholder="Choose Site"
                  onChange={(d) => setSite(d)}
                />
                {siteError ? <span>{"Selecting Site is required"}</span> : ""}
              </Col>
              {selectedItemsOpen.length > 0 && (
                <Col md="5 mb-3">
                  <Select
                    options={optionsCategory}
                    isSearchable={true}
                    placeholder="Select Distribution Board"
                    value={selectedDBname}
                    onChange={(option) => {
                      setSelectedDBname(option);
                      handleDB(option);
                    }}
                    menuPlacement="auto"
                    menuPosition="fixed"
                  />
                </Col>
              )}
              <Col md="2 mb-3">
                <Btn attrBtn={{ color: "primary", onClick: cancelForm }}>
                  Back
                </Btn>
                <Btn
                  attrBtn={{
                    color: "primary",
                    disabled: !selectedDB,
                    onClick: handleDeleteTasks,
                  }}
                >
                  Update DB
                </Btn>
              </Col>
            </Row>
            <CardBody>
              <div className="card-block row">
                <Col sm="12" lg="12" xl="12">
                  <br></br>
                  <br></br>
                  <Pagination
                    className="p-t-10"
                    pageSize={countPerPage}
                    onChange={updatePage3}
                    current={currentPage2}
                    total={fullassets.length}
                    showTotal={(total, range) =>
                      `${range[0]} - ${range[1]} of ${total} items`
                    }
                  />
                  <br></br>
                  <div className="table-responsive">
                    {isLoading && fullassets.length === 0 ? (
                      <tr>
                        <td colSpan="9" className="text-center">
                          <LoadingSpinner />
                        </td>
                      </tr>
                    ) : (
                      <Table className="table-striped table-de">
                        <thead className="custom-table-head">
                          <tr>
                            <th scope="col">
                              <input
                                type="checkbox"
                                checked={isAllSelectedOpen}
                                onChange={(event) =>
                                  handleCheckboxChangeOpen(event, "selectAll")
                                }
                              />
                            </th>
                            <th>Added On</th>
                            <th>Fitting Number</th>
                            <th>Asset Model</th>
                            <th>Site</th>
                            <th>Distribution Board</th>
                            <th>Installed On</th>
                            <th>Asset Location</th>
                            <th>Status</th>
                          </tr>
                        </thead>

                        <tbody className="trhover">
                          {tasks.length > 0 ? (
                            tasks
                              .sort(
                                (a, b) =>
                                  new Date(b.createdAt) - new Date(a.createdAt),
                              )
                              .map((item) => (
                                <tr key={item.id}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={selectedItemsOpen.includes(
                                        item.id,
                                      )}
                                      onChange={(event) =>
                                        handleCheckboxChangeOpen(event, item)
                                      }
                                    />
                                  </td>
                                  <td>
                                    {moment(item.createdAt).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </td>
                                  <td>{item.fittingNumber}</td>
                                  <td>{item.assetModel}</td>
                                  <td>{getSiteName(item.sitedetailsID)}</td>
                                  <td>{getDBName(item.distributionboxID)}</td>
                                  <td>
                                    {item.installedOn
                                      ? moment(item.installedOn).format(
                                          "DD/MM/YYYY",
                                        )
                                      : "-"}
                                  </td>
                                  <td>{item.assetLocation}</td>
                                  <td>{item.status}</td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="text-center">
                                No Assets available.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    )}
                  </div>
                </Col>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Container>
    </Fragment>
  );
  return (
    <div>
      {renderList}
      {errorMessage && <div className="error">{errorMessage}</div>}
    </div>
  );
};

export default UpdateDB;
